import { Slider } from "@/components/ui/slider"

function calculateStep(min: number, max: number): number {
  const range = max - min
  if (range <= 10) return 1
  if (range <= 100) return 5
  if (range <= 500) return 10
  if (range <= 1000) return 25
  if (range <= 5000) return 50
  if (range <= 10000) return 100
  return 250
}

interface QuestionRangeInputProps {
  value: number | undefined
  onChange: (value: number) => void
  disabled?: boolean
  min?: number
  max?: number
  unit?: string
  defaultValue?: number
}

export function QuestionRangeInput({
  value,
  onChange,
  disabled,
  min = 0,
  max = 100,
  unit = "",
  defaultValue,
}: QuestionRangeInputProps) {
  const step = calculateStep(min, max)
  const currentValue = value ?? defaultValue ?? min

  const handleSliderChange = (sliderValue: number | readonly number[]) => {
    const [newValue] = Array.isArray(sliderValue) ? sliderValue : [sliderValue]
    onChange(newValue)
  }

  return (
    <div className="space-y-2">
      <Slider
        value={[Math.min(max, Math.max(min, currentValue))]}
        onValueChange={handleSliderChange}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
      />
      <div className="flex items-center justify-between text-sm text-gray-11">
        <span>
          {min}
          {unit && <span> {unit}</span>}
        </span>
        <span className="font-medium text-gray-12">
          {currentValue}
          {unit && <span> {unit}</span>}
        </span>
        <span>
          {max}
          {unit && <span> {unit}</span>}
        </span>
      </div>
    </div>
  )
}
